'use client';

/**
 * This file was automatically generated by the Stencil React Output Target.
 * Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 */

/* eslint-disable */

import type { EventName, StencilReactComponent } from '@stencil/react-output-target/runtime';
import { createComponent } from '@stencil/react-output-target/runtime';
import React from 'react';

import { type CarouselItemOpenedDetail, type CarouselSlideChangedDetail, type ColorChangedDetail, type DatepickerDaySelectDetail, type DatepickerRangeSelectDetail, type Dayjs, type EditLabelConfirmDetail, type IZprPill, type MultiSelectOptionDeleteDetail, type MultiSelectOptionEditDetail, type SortChangedDetail, type TableColumnSelectDetail, type TableRowSelectDetail, type TableSelectionDetail, type TextFieldModalSubmitDetail, type TextInputChangeDetail, type ZprAccordionPanelCustomEvent, type ZprBaseCarouselCustomEvent, type ZprCarouselHorizontalCustomEvent, type ZprCarouselSingleCustomEvent, type ZprCarouselVerticalItemCustomEvent, type ZprCheckboxListChange, type ZprCheckboxListCustomEvent, type ZprCheckboxListDropdownClick, type ZprClipboardInputCustomEvent, type ZprColorpickerCustomEvent, type ZprDatepickerCustomEvent, type ZprDatepickerDaygridCustomEvent, type ZprDatepickerInputCustomEvent, type ZprDatepickerNavCustomEvent, type ZprDatepickerRangeCustomEvent, type ZprDropdownCustomEvent, type ZprDropdownMenuCustomEvent, type ZprDropzoneCustomEvent, type ZprDropzoneSingleImgCustomEvent, type ZprEditLabelCustomEvent, type ZprEditableTextCustomEvent, type ZprInlineInputCustomEvent, type ZprInputFileCustomEvent, type ZprInputNumberCustomEvent, type ZprLabelCustomEvent, type ZprLabelListCustomEvent, type ZprLabelRemovedDetail, type ZprModalConfirmCustomEvent, type ZprModalCustomEvent, type ZprModalMultistepCustomEvent, type ZprModalSplitCustomEvent, type ZprModalTextFieldCustomEvent, type ZprMultiSelectCustomEvent, type ZprPaginationCustomEvent, type ZprPillCustomEvent, type ZprPillListCustomEvent, type ZprProgressTabCustomEvent, type ZprProgressTabPanelCustomEvent, type ZprRadioItemCustomEvent, type ZprRadioListCustomEvent, type ZprRangeSelectorPanelCustomEvent, type ZprSelectCustomEvent, type ZprSelectWithFilterCustomEvent, type ZprSortDropdownCustomEvent, type ZprSwitcherButtonCustomEvent, type ZprTabCustomEvent, type ZprTableCustomEvent, type ZprTableTdImgCustomEvent, type ZprTableTrCustomEvent, type ZprTabsCustomEvent, type ZprTagsInputCustomEvent, type ZprTextInputCustomEvent, type ZprToggleCustomEvent, type ZprToggleItemCustomEvent, type ZprTooltipCustomEvent, type ZprTooltipInputCustomEvent } from "@zappar/zpr-ui-components-stencil";
import type { Components } from "@zappar/zpr-ui-components-stencil/dist/components";
import { ZprAccordionPanel as ZprAccordionPanelElement, defineCustomElement as defineZprAccordionPanel } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-accordion-panel.js";
import { ZprAccordion as ZprAccordionElement, defineCustomElement as defineZprAccordion } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-accordion.js";
import { ZprAlert as ZprAlertElement, defineCustomElement as defineZprAlert } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-alert.js";
import { ZprBannerSlide as ZprBannerSlideElement, defineCustomElement as defineZprBannerSlide } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-banner-slide.js";
import { ZprBaseCarousel as ZprBaseCarouselElement, defineCustomElement as defineZprBaseCarousel } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-base-carousel.js";
import { ZprCard as ZprCardElement, defineCustomElement as defineZprCard } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-card.js";
import { ZprCarouselHorizontalSlide as ZprCarouselHorizontalSlideElement, defineCustomElement as defineZprCarouselHorizontalSlide } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-carousel-horizontal-slide.js";
import { ZprCarouselHorizontal as ZprCarouselHorizontalElement, defineCustomElement as defineZprCarouselHorizontal } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-carousel-horizontal.js";
import { ZprCarouselSingle as ZprCarouselSingleElement, defineCustomElement as defineZprCarouselSingle } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-carousel-single.js";
import { ZprCarouselVerticalItem as ZprCarouselVerticalItemElement, defineCustomElement as defineZprCarouselVerticalItem } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-carousel-vertical-item.js";
import { ZprCarouselVertical as ZprCarouselVerticalElement, defineCustomElement as defineZprCarouselVertical } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-carousel-vertical.js";
import { ZprCheckboxList as ZprCheckboxListElement, defineCustomElement as defineZprCheckboxList } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-checkbox-list.js";
import { ZprClipboardInput as ZprClipboardInputElement, defineCustomElement as defineZprClipboardInput } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-clipboard-input.js";
import { ZprColorpicker as ZprColorpickerElement, defineCustomElement as defineZprColorpicker } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-colorpicker.js";
import { ZprDatepickerDaygrid as ZprDatepickerDaygridElement, defineCustomElement as defineZprDatepickerDaygrid } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-datepicker-daygrid.js";
import { ZprDatepickerInput as ZprDatepickerInputElement, defineCustomElement as defineZprDatepickerInput } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-datepicker-input.js";
import { ZprDatepickerNav as ZprDatepickerNavElement, defineCustomElement as defineZprDatepickerNav } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-datepicker-nav.js";
import { ZprDatepickerRange as ZprDatepickerRangeElement, defineCustomElement as defineZprDatepickerRange } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-datepicker-range.js";
import { ZprDatepicker as ZprDatepickerElement, defineCustomElement as defineZprDatepicker } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-datepicker.js";
import { ZprDropdownMenu as ZprDropdownMenuElement, defineCustomElement as defineZprDropdownMenu } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-dropdown-menu.js";
import { ZprDropdown as ZprDropdownElement, defineCustomElement as defineZprDropdown } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-dropdown.js";
import { ZprDropzoneSingleImg as ZprDropzoneSingleImgElement, defineCustomElement as defineZprDropzoneSingleImg } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-dropzone-single-img.js";
import { ZprDropzone as ZprDropzoneElement, defineCustomElement as defineZprDropzone } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-dropzone.js";
import { ZprEditLabel as ZprEditLabelElement, defineCustomElement as defineZprEditLabel } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-edit-label.js";
import { ZprEditableText as ZprEditableTextElement, defineCustomElement as defineZprEditableText } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-editable-text.js";
import { ZprEmptyState as ZprEmptyStateElement, defineCustomElement as defineZprEmptyState } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-empty-state.js";
import { ZprFieldsetLabel as ZprFieldsetLabelElement, defineCustomElement as defineZprFieldsetLabel } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-fieldset-label.js";
import { ZprFieldset as ZprFieldsetElement, defineCustomElement as defineZprFieldset } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-fieldset.js";
import { ZprInlineInput as ZprInlineInputElement, defineCustomElement as defineZprInlineInput } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-inline-input.js";
import { ZprInputFile as ZprInputFileElement, defineCustomElement as defineZprInputFile } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-input-file.js";
import { ZprInputNumber as ZprInputNumberElement, defineCustomElement as defineZprInputNumber } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-input-number.js";
import { ZprLabelList as ZprLabelListElement, defineCustomElement as defineZprLabelList } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-label-list.js";
import { ZprLabel as ZprLabelElement, defineCustomElement as defineZprLabel } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-label.js";
import { ZprLightbox as ZprLightboxElement, defineCustomElement as defineZprLightbox } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-lightbox.js";
import { ZprModalConfirm as ZprModalConfirmElement, defineCustomElement as defineZprModalConfirm } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-modal-confirm.js";
import { ZprModalMultistep as ZprModalMultistepElement, defineCustomElement as defineZprModalMultistep } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-modal-multistep.js";
import { ZprModalSplit as ZprModalSplitElement, defineCustomElement as defineZprModalSplit } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-modal-split.js";
import { ZprModalStep as ZprModalStepElement, defineCustomElement as defineZprModalStep } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-modal-step.js";
import { ZprModalTextField as ZprModalTextFieldElement, defineCustomElement as defineZprModalTextField } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-modal-text-field.js";
import { ZprModal as ZprModalElement, defineCustomElement as defineZprModal } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-modal.js";
import { ZprMultiSelect as ZprMultiSelectElement, defineCustomElement as defineZprMultiSelect } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-multi-select.js";
import { ZprPagination as ZprPaginationElement, defineCustomElement as defineZprPagination } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-pagination.js";
import { ZprPassword as ZprPasswordElement, defineCustomElement as defineZprPassword } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-password.js";
import { ZprPillList as ZprPillListElement, defineCustomElement as defineZprPillList } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-pill-list.js";
import { ZprPill as ZprPillElement, defineCustomElement as defineZprPill } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-pill.js";
import { ZprPricingPlan as ZprPricingPlanElement, defineCustomElement as defineZprPricingPlan } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-pricing-plan.js";
import { ZprPricingPlans as ZprPricingPlansElement, defineCustomElement as defineZprPricingPlans } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-pricing-plans.js";
import { ZprProgressRing as ZprProgressRingElement, defineCustomElement as defineZprProgressRing } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-progress-ring.js";
import { ZprProgressTabPanel as ZprProgressTabPanelElement, defineCustomElement as defineZprProgressTabPanel } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-progress-tab-panel.js";
import { ZprProgressTab as ZprProgressTabElement, defineCustomElement as defineZprProgressTab } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-progress-tab.js";
import { ZprProgressTabs as ZprProgressTabsElement, defineCustomElement as defineZprProgressTabs } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-progress-tabs.js";
import { ZprRadioItem as ZprRadioItemElement, defineCustomElement as defineZprRadioItem } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-radio-item.js";
import { ZprRadioList as ZprRadioListElement, defineCustomElement as defineZprRadioList } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-radio-list.js";
import { ZprRangeSelectorPanel as ZprRangeSelectorPanelElement, defineCustomElement as defineZprRangeSelectorPanel } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-range-selector-panel.js";
import { ZprSelectOptionGroup as ZprSelectOptionGroupElement, defineCustomElement as defineZprSelectOptionGroup } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-select-option-group.js";
import { ZprSelectOption as ZprSelectOptionElement, defineCustomElement as defineZprSelectOption } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-select-option.js";
import { ZprSelectWithFilter as ZprSelectWithFilterElement, defineCustomElement as defineZprSelectWithFilter } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-select-with-filter.js";
import { ZprSelect as ZprSelectElement, defineCustomElement as defineZprSelect } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-select.js";
import { ZprSortDropdown as ZprSortDropdownElement, defineCustomElement as defineZprSortDropdown } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-sort-dropdown.js";
import { ZprStepProgress as ZprStepProgressElement, defineCustomElement as defineZprStepProgress } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-step-progress.js";
import { ZprSwitcherButtonItem as ZprSwitcherButtonItemElement, defineCustomElement as defineZprSwitcherButtonItem } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-switcher-button-item.js";
import { ZprSwitcherButton as ZprSwitcherButtonElement, defineCustomElement as defineZprSwitcherButton } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-switcher-button.js";
import { ZprTab as ZprTabElement, defineCustomElement as defineZprTab } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-tab.js";
import { ZprTableTdAction as ZprTableTdActionElement, defineCustomElement as defineZprTableTdAction } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-table-td-action.js";
import { ZprTableTdImg as ZprTableTdImgElement, defineCustomElement as defineZprTableTdImg } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-table-td-img.js";
import { ZprTableTd as ZprTableTdElement, defineCustomElement as defineZprTableTd } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-table-td.js";
import { ZprTableTr as ZprTableTrElement, defineCustomElement as defineZprTableTr } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-table-tr.js";
import { ZprTable as ZprTableElement, defineCustomElement as defineZprTable } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-table.js";
import { ZprTabsVertical as ZprTabsVerticalElement, defineCustomElement as defineZprTabsVertical } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-tabs-vertical.js";
import { ZprTabs as ZprTabsElement, defineCustomElement as defineZprTabs } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-tabs.js";
import { ZprTagsInput as ZprTagsInputElement, defineCustomElement as defineZprTagsInput } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-tags-input.js";
import { ZprTagsList as ZprTagsListElement, defineCustomElement as defineZprTagsList } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-tags-list.js";
import { ZprTextInput as ZprTextInputElement, defineCustomElement as defineZprTextInput } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-text-input.js";
import { ZprToast as ZprToastElement, defineCustomElement as defineZprToast } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-toast.js";
import { ZprToasts as ZprToastsElement, defineCustomElement as defineZprToasts } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-toasts.js";
import { ZprToggleItem as ZprToggleItemElement, defineCustomElement as defineZprToggleItem } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-toggle-item.js";
import { ZprToggle as ZprToggleElement, defineCustomElement as defineZprToggle } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-toggle.js";
import { ZprTooltipInput as ZprTooltipInputElement, defineCustomElement as defineZprTooltipInput } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-tooltip-input.js";
import { ZprTooltip as ZprTooltipElement, defineCustomElement as defineZprTooltip } from "@zappar/zpr-ui-components-stencil/dist/components/zpr-tooltip.js";

export type ZprAccordionEvents = NonNullable<unknown>;

export const ZprAccordion: StencilReactComponent<ZprAccordionElement, ZprAccordionEvents, Components.ZprAccordion> = /*@__PURE__*/ createComponent<ZprAccordionElement, ZprAccordionEvents, Components.ZprAccordion>({
    tagName: 'zpr-accordion',
    elementClass: ZprAccordionElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprAccordionEvents,
    defineCustomElement: defineZprAccordion
});

export type ZprAccordionPanelEvents = { onPanelOpened: EventName<ZprAccordionPanelCustomEvent<any>> };

export const ZprAccordionPanel: StencilReactComponent<ZprAccordionPanelElement, ZprAccordionPanelEvents, Components.ZprAccordionPanel> = /*@__PURE__*/ createComponent<ZprAccordionPanelElement, ZprAccordionPanelEvents, Components.ZprAccordionPanel>({
    tagName: 'zpr-accordion-panel',
    elementClass: ZprAccordionPanelElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onPanelOpened: 'panelOpened' } as ZprAccordionPanelEvents,
    defineCustomElement: defineZprAccordionPanel
});

export type ZprAlertEvents = NonNullable<unknown>;

export const ZprAlert: StencilReactComponent<ZprAlertElement, ZprAlertEvents, Components.ZprAlert> = /*@__PURE__*/ createComponent<ZprAlertElement, ZprAlertEvents, Components.ZprAlert>({
    tagName: 'zpr-alert',
    elementClass: ZprAlertElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprAlertEvents,
    defineCustomElement: defineZprAlert
});

export type ZprBannerSlideEvents = NonNullable<unknown>;

export const ZprBannerSlide: StencilReactComponent<ZprBannerSlideElement, ZprBannerSlideEvents, Components.ZprBannerSlide> = /*@__PURE__*/ createComponent<ZprBannerSlideElement, ZprBannerSlideEvents, Components.ZprBannerSlide>({
    tagName: 'zpr-banner-slide',
    elementClass: ZprBannerSlideElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprBannerSlideEvents,
    defineCustomElement: defineZprBannerSlide
});

export type ZprBaseCarouselEvents = { onSlideChanged: EventName<ZprBaseCarouselCustomEvent<CarouselSlideChangedDetail>> };

export const ZprBaseCarousel: StencilReactComponent<ZprBaseCarouselElement, ZprBaseCarouselEvents, Components.ZprBaseCarousel> = /*@__PURE__*/ createComponent<ZprBaseCarouselElement, ZprBaseCarouselEvents, Components.ZprBaseCarousel>({
    tagName: 'zpr-base-carousel',
    elementClass: ZprBaseCarouselElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onSlideChanged: 'slide-changed' } as ZprBaseCarouselEvents,
    defineCustomElement: defineZprBaseCarousel
});

export type ZprCardEvents = NonNullable<unknown>;

export const ZprCard: StencilReactComponent<ZprCardElement, ZprCardEvents, Components.ZprCard> = /*@__PURE__*/ createComponent<ZprCardElement, ZprCardEvents, Components.ZprCard>({
    tagName: 'zpr-card',
    elementClass: ZprCardElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprCardEvents,
    defineCustomElement: defineZprCard
});

export type ZprCarouselHorizontalEvents = { onSlideChanged: EventName<ZprCarouselHorizontalCustomEvent<CarouselSlideChangedDetail>> };

export const ZprCarouselHorizontal: StencilReactComponent<ZprCarouselHorizontalElement, ZprCarouselHorizontalEvents, Components.ZprCarouselHorizontal> = /*@__PURE__*/ createComponent<ZprCarouselHorizontalElement, ZprCarouselHorizontalEvents, Components.ZprCarouselHorizontal>({
    tagName: 'zpr-carousel-horizontal',
    elementClass: ZprCarouselHorizontalElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onSlideChanged: 'slide-changed' } as ZprCarouselHorizontalEvents,
    defineCustomElement: defineZprCarouselHorizontal
});

export type ZprCarouselHorizontalSlideEvents = NonNullable<unknown>;

export const ZprCarouselHorizontalSlide: StencilReactComponent<ZprCarouselHorizontalSlideElement, ZprCarouselHorizontalSlideEvents, Components.ZprCarouselHorizontalSlide> = /*@__PURE__*/ createComponent<ZprCarouselHorizontalSlideElement, ZprCarouselHorizontalSlideEvents, Components.ZprCarouselHorizontalSlide>({
    tagName: 'zpr-carousel-horizontal-slide',
    elementClass: ZprCarouselHorizontalSlideElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprCarouselHorizontalSlideEvents,
    defineCustomElement: defineZprCarouselHorizontalSlide
});

export type ZprCarouselSingleEvents = { onSlideChanged: EventName<ZprCarouselSingleCustomEvent<CarouselSlideChangedDetail>> };

export const ZprCarouselSingle: StencilReactComponent<ZprCarouselSingleElement, ZprCarouselSingleEvents, Components.ZprCarouselSingle> = /*@__PURE__*/ createComponent<ZprCarouselSingleElement, ZprCarouselSingleEvents, Components.ZprCarouselSingle>({
    tagName: 'zpr-carousel-single',
    elementClass: ZprCarouselSingleElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onSlideChanged: 'slide-changed' } as ZprCarouselSingleEvents,
    defineCustomElement: defineZprCarouselSingle
});

export type ZprCarouselVerticalEvents = NonNullable<unknown>;

export const ZprCarouselVertical: StencilReactComponent<ZprCarouselVerticalElement, ZprCarouselVerticalEvents, Components.ZprCarouselVertical> = /*@__PURE__*/ createComponent<ZprCarouselVerticalElement, ZprCarouselVerticalEvents, Components.ZprCarouselVertical>({
    tagName: 'zpr-carousel-vertical',
    elementClass: ZprCarouselVerticalElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprCarouselVerticalEvents,
    defineCustomElement: defineZprCarouselVertical
});

export type ZprCarouselVerticalItemEvents = { onItemOpened: EventName<ZprCarouselVerticalItemCustomEvent<CarouselItemOpenedDetail>> };

export const ZprCarouselVerticalItem: StencilReactComponent<ZprCarouselVerticalItemElement, ZprCarouselVerticalItemEvents, Components.ZprCarouselVerticalItem> = /*@__PURE__*/ createComponent<ZprCarouselVerticalItemElement, ZprCarouselVerticalItemEvents, Components.ZprCarouselVerticalItem>({
    tagName: 'zpr-carousel-vertical-item',
    elementClass: ZprCarouselVerticalItemElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onItemOpened: 'item-opened' } as ZprCarouselVerticalItemEvents,
    defineCustomElement: defineZprCarouselVerticalItem
});

export type ZprCheckboxListEvents = {
    onCheckboxListChanged: EventName<ZprCheckboxListCustomEvent<ZprCheckboxListChange>>,
    onDropdownClicked: EventName<ZprCheckboxListCustomEvent<ZprCheckboxListDropdownClick>>
};

export const ZprCheckboxList: StencilReactComponent<ZprCheckboxListElement, ZprCheckboxListEvents, Components.ZprCheckboxList> = /*@__PURE__*/ createComponent<ZprCheckboxListElement, ZprCheckboxListEvents, Components.ZprCheckboxList>({
    tagName: 'zpr-checkbox-list',
    elementClass: ZprCheckboxListElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onCheckboxListChanged: 'checkbox-list-changed',
        onDropdownClicked: 'dropdown-clicked'
    } as ZprCheckboxListEvents,
    defineCustomElement: defineZprCheckboxList
});

export type ZprClipboardInputEvents = { onCopied: EventName<ZprClipboardInputCustomEvent<any>> };

export const ZprClipboardInput: StencilReactComponent<ZprClipboardInputElement, ZprClipboardInputEvents, Components.ZprClipboardInput> = /*@__PURE__*/ createComponent<ZprClipboardInputElement, ZprClipboardInputEvents, Components.ZprClipboardInput>({
    tagName: 'zpr-clipboard-input',
    elementClass: ZprClipboardInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onCopied: 'copied' } as ZprClipboardInputEvents,
    defineCustomElement: defineZprClipboardInput
});

export type ZprColorpickerEvents = { onColorChanged: EventName<ZprColorpickerCustomEvent<ColorChangedDetail>> };

export const ZprColorpicker: StencilReactComponent<ZprColorpickerElement, ZprColorpickerEvents, Components.ZprColorpicker> = /*@__PURE__*/ createComponent<ZprColorpickerElement, ZprColorpickerEvents, Components.ZprColorpicker>({
    tagName: 'zpr-colorpicker',
    elementClass: ZprColorpickerElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onColorChanged: 'color-changed' } as ZprColorpickerEvents,
    defineCustomElement: defineZprColorpicker
});

export type ZprDatepickerEvents = { onDatepickerDateClear: EventName<ZprDatepickerCustomEvent<void>> };

export const ZprDatepicker: StencilReactComponent<ZprDatepickerElement, ZprDatepickerEvents, Components.ZprDatepicker> = /*@__PURE__*/ createComponent<ZprDatepickerElement, ZprDatepickerEvents, Components.ZprDatepicker>({
    tagName: 'zpr-datepicker',
    elementClass: ZprDatepickerElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onDatepickerDateClear: 'datepicker-date-clear' } as ZprDatepickerEvents,
    defineCustomElement: defineZprDatepicker
});

export type ZprDatepickerDaygridEvents = { onDatepickerDaySelect: EventName<ZprDatepickerDaygridCustomEvent<DatepickerDaySelectDetail>> };

export const ZprDatepickerDaygrid: StencilReactComponent<ZprDatepickerDaygridElement, ZprDatepickerDaygridEvents, Components.ZprDatepickerDaygrid> = /*@__PURE__*/ createComponent<ZprDatepickerDaygridElement, ZprDatepickerDaygridEvents, Components.ZprDatepickerDaygrid>({
    tagName: 'zpr-datepicker-daygrid',
    elementClass: ZprDatepickerDaygridElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onDatepickerDaySelect: 'datepicker-day-select' } as ZprDatepickerDaygridEvents,
    defineCustomElement: defineZprDatepickerDaygrid
});

export type ZprDatepickerInputEvents = { onDateSelected: EventName<ZprDatepickerInputCustomEvent<Dayjs>> };

export const ZprDatepickerInput: StencilReactComponent<ZprDatepickerInputElement, ZprDatepickerInputEvents, Components.ZprDatepickerInput> = /*@__PURE__*/ createComponent<ZprDatepickerInputElement, ZprDatepickerInputEvents, Components.ZprDatepickerInput>({
    tagName: 'zpr-datepicker-input',
    elementClass: ZprDatepickerInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onDateSelected: 'date-selected' } as ZprDatepickerInputEvents,
    defineCustomElement: defineZprDatepickerInput
});

export type ZprDatepickerNavEvents = { onDatepickerNavDateChange: EventName<ZprDatepickerNavCustomEvent<Dayjs>> };

export const ZprDatepickerNav: StencilReactComponent<ZprDatepickerNavElement, ZprDatepickerNavEvents, Components.ZprDatepickerNav> = /*@__PURE__*/ createComponent<ZprDatepickerNavElement, ZprDatepickerNavEvents, Components.ZprDatepickerNav>({
    tagName: 'zpr-datepicker-nav',
    elementClass: ZprDatepickerNavElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onDatepickerNavDateChange: 'datepicker-nav-date-change' } as ZprDatepickerNavEvents,
    defineCustomElement: defineZprDatepickerNav
});

export type ZprDatepickerRangeEvents = { onDatepickerRangeSelect: EventName<ZprDatepickerRangeCustomEvent<DatepickerRangeSelectDetail>> };

export const ZprDatepickerRange: StencilReactComponent<ZprDatepickerRangeElement, ZprDatepickerRangeEvents, Components.ZprDatepickerRange> = /*@__PURE__*/ createComponent<ZprDatepickerRangeElement, ZprDatepickerRangeEvents, Components.ZprDatepickerRange>({
    tagName: 'zpr-datepicker-range',
    elementClass: ZprDatepickerRangeElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onDatepickerRangeSelect: 'datepicker-range-select' } as ZprDatepickerRangeEvents,
    defineCustomElement: defineZprDatepickerRange
});

export type ZprDropdownEvents = { onDropdownOpen: EventName<ZprDropdownCustomEvent<boolean>> };

export const ZprDropdown: StencilReactComponent<ZprDropdownElement, ZprDropdownEvents, Components.ZprDropdown> = /*@__PURE__*/ createComponent<ZprDropdownElement, ZprDropdownEvents, Components.ZprDropdown>({
    tagName: 'zpr-dropdown',
    elementClass: ZprDropdownElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onDropdownOpen: 'dropdown-open' } as ZprDropdownEvents,
    defineCustomElement: defineZprDropdown
});

export type ZprDropdownMenuEvents = { onOpenChanged: EventName<ZprDropdownMenuCustomEvent<boolean>> };

export const ZprDropdownMenu: StencilReactComponent<ZprDropdownMenuElement, ZprDropdownMenuEvents, Components.ZprDropdownMenu> = /*@__PURE__*/ createComponent<ZprDropdownMenuElement, ZprDropdownMenuEvents, Components.ZprDropdownMenu>({
    tagName: 'zpr-dropdown-menu',
    elementClass: ZprDropdownMenuElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onOpenChanged: 'openChanged' } as ZprDropdownMenuEvents,
    defineCustomElement: defineZprDropdownMenu
});

export type ZprDropzoneEvents = { onFilesdropped: EventName<ZprDropzoneCustomEvent<DataTransfer>> };

export const ZprDropzone: StencilReactComponent<ZprDropzoneElement, ZprDropzoneEvents, Components.ZprDropzone> = /*@__PURE__*/ createComponent<ZprDropzoneElement, ZprDropzoneEvents, Components.ZprDropzone>({
    tagName: 'zpr-dropzone',
    elementClass: ZprDropzoneElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onFilesdropped: 'filesdropped' } as ZprDropzoneEvents,
    defineCustomElement: defineZprDropzone
});

export type ZprDropzoneSingleImgEvents = { onImageDeleted: EventName<ZprDropzoneSingleImgCustomEvent<void>> };

export const ZprDropzoneSingleImg: StencilReactComponent<ZprDropzoneSingleImgElement, ZprDropzoneSingleImgEvents, Components.ZprDropzoneSingleImg> = /*@__PURE__*/ createComponent<ZprDropzoneSingleImgElement, ZprDropzoneSingleImgEvents, Components.ZprDropzoneSingleImg>({
    tagName: 'zpr-dropzone-single-img',
    elementClass: ZprDropzoneSingleImgElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onImageDeleted: 'image-deleted' } as ZprDropzoneSingleImgEvents,
    defineCustomElement: defineZprDropzoneSingleImg
});

export type ZprEditLabelEvents = {
    onEditLabelConfirm: EventName<ZprEditLabelCustomEvent<EditLabelConfirmDetail>>,
    onEditLabelCancel: EventName<ZprEditLabelCustomEvent<void>>
};

export const ZprEditLabel: StencilReactComponent<ZprEditLabelElement, ZprEditLabelEvents, Components.ZprEditLabel> = /*@__PURE__*/ createComponent<ZprEditLabelElement, ZprEditLabelEvents, Components.ZprEditLabel>({
    tagName: 'zpr-edit-label',
    elementClass: ZprEditLabelElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onEditLabelConfirm: 'edit-label-confirm',
        onEditLabelCancel: 'edit-label-cancel'
    } as ZprEditLabelEvents,
    defineCustomElement: defineZprEditLabel
});

export type ZprEditableTextEvents = { onValueChanged: EventName<ZprEditableTextCustomEvent<string>> };

export const ZprEditableText: StencilReactComponent<ZprEditableTextElement, ZprEditableTextEvents, Components.ZprEditableText> = /*@__PURE__*/ createComponent<ZprEditableTextElement, ZprEditableTextEvents, Components.ZprEditableText>({
    tagName: 'zpr-editable-text',
    elementClass: ZprEditableTextElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onValueChanged: 'value-changed' } as ZprEditableTextEvents,
    defineCustomElement: defineZprEditableText
});

export type ZprEmptyStateEvents = NonNullable<unknown>;

export const ZprEmptyState: StencilReactComponent<ZprEmptyStateElement, ZprEmptyStateEvents, Components.ZprEmptyState> = /*@__PURE__*/ createComponent<ZprEmptyStateElement, ZprEmptyStateEvents, Components.ZprEmptyState>({
    tagName: 'zpr-empty-state',
    elementClass: ZprEmptyStateElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprEmptyStateEvents,
    defineCustomElement: defineZprEmptyState
});

export type ZprFieldsetEvents = NonNullable<unknown>;

export const ZprFieldset: StencilReactComponent<ZprFieldsetElement, ZprFieldsetEvents, Components.ZprFieldset> = /*@__PURE__*/ createComponent<ZprFieldsetElement, ZprFieldsetEvents, Components.ZprFieldset>({
    tagName: 'zpr-fieldset',
    elementClass: ZprFieldsetElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprFieldsetEvents,
    defineCustomElement: defineZprFieldset
});

export type ZprFieldsetLabelEvents = NonNullable<unknown>;

export const ZprFieldsetLabel: StencilReactComponent<ZprFieldsetLabelElement, ZprFieldsetLabelEvents, Components.ZprFieldsetLabel> = /*@__PURE__*/ createComponent<ZprFieldsetLabelElement, ZprFieldsetLabelEvents, Components.ZprFieldsetLabel>({
    tagName: 'zpr-fieldset-label',
    elementClass: ZprFieldsetLabelElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprFieldsetLabelEvents,
    defineCustomElement: defineZprFieldsetLabel
});

export type ZprInlineInputEvents = {
    onValueChange: EventName<ZprInlineInputCustomEvent<string>>,
    onEdit: EventName<ZprInlineInputCustomEvent<void>>
};

export const ZprInlineInput: StencilReactComponent<ZprInlineInputElement, ZprInlineInputEvents, Components.ZprInlineInput> = /*@__PURE__*/ createComponent<ZprInlineInputElement, ZprInlineInputEvents, Components.ZprInlineInput>({
    tagName: 'zpr-inline-input',
    elementClass: ZprInlineInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValueChange: 'value-change',
        onEdit: 'edit'
    } as ZprInlineInputEvents,
    defineCustomElement: defineZprInlineInput
});

export type ZprInputFileEvents = { onInputFile: EventName<ZprInputFileCustomEvent<DataTransfer>> };

export const ZprInputFile: StencilReactComponent<ZprInputFileElement, ZprInputFileEvents, Components.ZprInputFile> = /*@__PURE__*/ createComponent<ZprInputFileElement, ZprInputFileEvents, Components.ZprInputFile>({
    tagName: 'zpr-input-file',
    elementClass: ZprInputFileElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onInputFile: 'input-file' } as ZprInputFileEvents,
    defineCustomElement: defineZprInputFile
});

export type ZprInputNumberEvents = { onValueChanged: EventName<ZprInputNumberCustomEvent<string>> };

export const ZprInputNumber: StencilReactComponent<ZprInputNumberElement, ZprInputNumberEvents, Components.ZprInputNumber> = /*@__PURE__*/ createComponent<ZprInputNumberElement, ZprInputNumberEvents, Components.ZprInputNumber>({
    tagName: 'zpr-input-number',
    elementClass: ZprInputNumberElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onValueChanged: 'value-changed' } as ZprInputNumberEvents,
    defineCustomElement: defineZprInputNumber
});

export type ZprLabelEvents = { onLabelRemove: EventName<ZprLabelCustomEvent<string>> };

export const ZprLabel: StencilReactComponent<ZprLabelElement, ZprLabelEvents, Components.ZprLabel> = /*@__PURE__*/ createComponent<ZprLabelElement, ZprLabelEvents, Components.ZprLabel>({
    tagName: 'zpr-label',
    elementClass: ZprLabelElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onLabelRemove: 'label-remove' } as ZprLabelEvents,
    defineCustomElement: defineZprLabel
});

export type ZprLabelListEvents = { onLabelRemoved: EventName<ZprLabelListCustomEvent<ZprLabelRemovedDetail>> };

export const ZprLabelList: StencilReactComponent<ZprLabelListElement, ZprLabelListEvents, Components.ZprLabelList> = /*@__PURE__*/ createComponent<ZprLabelListElement, ZprLabelListEvents, Components.ZprLabelList>({
    tagName: 'zpr-label-list',
    elementClass: ZprLabelListElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onLabelRemoved: 'label-removed' } as ZprLabelListEvents,
    defineCustomElement: defineZprLabelList
});

export type ZprLightboxEvents = NonNullable<unknown>;

export const ZprLightbox: StencilReactComponent<ZprLightboxElement, ZprLightboxEvents, Components.ZprLightbox> = /*@__PURE__*/ createComponent<ZprLightboxElement, ZprLightboxEvents, Components.ZprLightbox>({
    tagName: 'zpr-lightbox',
    elementClass: ZprLightboxElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprLightboxEvents,
    defineCustomElement: defineZprLightbox
});

export type ZprModalEvents = {
    onClosed: EventName<ZprModalCustomEvent<any>>,
    onOpened: EventName<ZprModalCustomEvent<any>>
};

export const ZprModal: StencilReactComponent<ZprModalElement, ZprModalEvents, Components.ZprModal> = /*@__PURE__*/ createComponent<ZprModalElement, ZprModalEvents, Components.ZprModal>({
    tagName: 'zpr-modal',
    elementClass: ZprModalElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onClosed: 'closed',
        onOpened: 'opened'
    } as ZprModalEvents,
    defineCustomElement: defineZprModal
});

export type ZprModalConfirmEvents = {
    onConfirmed: EventName<ZprModalConfirmCustomEvent<any>>,
    onRejected: EventName<ZprModalConfirmCustomEvent<any>>
};

export const ZprModalConfirm: StencilReactComponent<ZprModalConfirmElement, ZprModalConfirmEvents, Components.ZprModalConfirm> = /*@__PURE__*/ createComponent<ZprModalConfirmElement, ZprModalConfirmEvents, Components.ZprModalConfirm>({
    tagName: 'zpr-modal-confirm',
    elementClass: ZprModalConfirmElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onConfirmed: 'confirmed',
        onRejected: 'rejected'
    } as ZprModalConfirmEvents,
    defineCustomElement: defineZprModalConfirm
});

export type ZprModalMultistepEvents = {
    onOpened: EventName<ZprModalMultistepCustomEvent<any>>,
    onClosed: EventName<ZprModalMultistepCustomEvent<any>>,
    onModalStepChanged: EventName<ZprModalMultistepCustomEvent<string>>
};

export const ZprModalMultistep: StencilReactComponent<ZprModalMultistepElement, ZprModalMultistepEvents, Components.ZprModalMultistep> = /*@__PURE__*/ createComponent<ZprModalMultistepElement, ZprModalMultistepEvents, Components.ZprModalMultistep>({
    tagName: 'zpr-modal-multistep',
    elementClass: ZprModalMultistepElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onOpened: 'opened',
        onClosed: 'closed',
        onModalStepChanged: 'modal-step-changed'
    } as ZprModalMultistepEvents,
    defineCustomElement: defineZprModalMultistep
});

export type ZprModalSplitEvents = {
    onClosed: EventName<ZprModalSplitCustomEvent<any>>,
    onOpened: EventName<ZprModalSplitCustomEvent<any>>
};

export const ZprModalSplit: StencilReactComponent<ZprModalSplitElement, ZprModalSplitEvents, Components.ZprModalSplit> = /*@__PURE__*/ createComponent<ZprModalSplitElement, ZprModalSplitEvents, Components.ZprModalSplit>({
    tagName: 'zpr-modal-split',
    elementClass: ZprModalSplitElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onClosed: 'closed',
        onOpened: 'opened'
    } as ZprModalSplitEvents,
    defineCustomElement: defineZprModalSplit
});

export type ZprModalStepEvents = NonNullable<unknown>;

export const ZprModalStep: StencilReactComponent<ZprModalStepElement, ZprModalStepEvents, Components.ZprModalStep> = /*@__PURE__*/ createComponent<ZprModalStepElement, ZprModalStepEvents, Components.ZprModalStep>({
    tagName: 'zpr-modal-step',
    elementClass: ZprModalStepElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprModalStepEvents,
    defineCustomElement: defineZprModalStep
});

export type ZprModalTextFieldEvents = {
    onSubmitted: EventName<ZprModalTextFieldCustomEvent<TextFieldModalSubmitDetail>>,
    onCancelled: EventName<ZprModalTextFieldCustomEvent<void>>
};

export const ZprModalTextField: StencilReactComponent<ZprModalTextFieldElement, ZprModalTextFieldEvents, Components.ZprModalTextField> = /*@__PURE__*/ createComponent<ZprModalTextFieldElement, ZprModalTextFieldEvents, Components.ZprModalTextField>({
    tagName: 'zpr-modal-text-field',
    elementClass: ZprModalTextFieldElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onSubmitted: 'submitted',
        onCancelled: 'cancelled'
    } as ZprModalTextFieldEvents,
    defineCustomElement: defineZprModalTextField
});

export type ZprMultiSelectEvents = {
    onSelectionchanged: EventName<ZprMultiSelectCustomEvent<string[]>>,
    onCreateOption: EventName<ZprMultiSelectCustomEvent<string>>,
    onOptionEdit: EventName<ZprMultiSelectCustomEvent<MultiSelectOptionEditDetail>>,
    onOptionDelete: EventName<ZprMultiSelectCustomEvent<MultiSelectOptionDeleteDetail>>
};

export const ZprMultiSelect: StencilReactComponent<ZprMultiSelectElement, ZprMultiSelectEvents, Components.ZprMultiSelect> = /*@__PURE__*/ createComponent<ZprMultiSelectElement, ZprMultiSelectEvents, Components.ZprMultiSelect>({
    tagName: 'zpr-multi-select',
    elementClass: ZprMultiSelectElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onSelectionchanged: 'selectionchanged',
        onCreateOption: 'create-option',
        onOptionEdit: 'option-edit',
        onOptionDelete: 'option-delete'
    } as ZprMultiSelectEvents,
    defineCustomElement: defineZprMultiSelect
});

export type ZprPaginationEvents = { onPagechanged: EventName<ZprPaginationCustomEvent<number>> };

export const ZprPagination: StencilReactComponent<ZprPaginationElement, ZprPaginationEvents, Components.ZprPagination> = /*@__PURE__*/ createComponent<ZprPaginationElement, ZprPaginationEvents, Components.ZprPagination>({
    tagName: 'zpr-pagination',
    elementClass: ZprPaginationElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onPagechanged: 'pagechanged' } as ZprPaginationEvents,
    defineCustomElement: defineZprPagination
});

export type ZprPasswordEvents = NonNullable<unknown>;

export const ZprPassword: StencilReactComponent<ZprPasswordElement, ZprPasswordEvents, Components.ZprPassword> = /*@__PURE__*/ createComponent<ZprPasswordElement, ZprPasswordEvents, Components.ZprPassword>({
    tagName: 'zpr-password',
    elementClass: ZprPasswordElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprPasswordEvents,
    defineCustomElement: defineZprPassword
});

export type ZprPillEvents = { onPillToggled: EventName<ZprPillCustomEvent<boolean>> };

export const ZprPill: StencilReactComponent<ZprPillElement, ZprPillEvents, Components.ZprPill> = /*@__PURE__*/ createComponent<ZprPillElement, ZprPillEvents, Components.ZprPill>({
    tagName: 'zpr-pill',
    elementClass: ZprPillElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onPillToggled: 'pill-toggled' } as ZprPillEvents,
    defineCustomElement: defineZprPill
});

export type ZprPillListEvents = { onPillRemoved: EventName<ZprPillListCustomEvent<IZprPill>> };

export const ZprPillList: StencilReactComponent<ZprPillListElement, ZprPillListEvents, Components.ZprPillList> = /*@__PURE__*/ createComponent<ZprPillListElement, ZprPillListEvents, Components.ZprPillList>({
    tagName: 'zpr-pill-list',
    elementClass: ZprPillListElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onPillRemoved: 'pill-removed' } as ZprPillListEvents,
    defineCustomElement: defineZprPillList
});

export type ZprPricingPlanEvents = NonNullable<unknown>;

export const ZprPricingPlan: StencilReactComponent<ZprPricingPlanElement, ZprPricingPlanEvents, Components.ZprPricingPlan> = /*@__PURE__*/ createComponent<ZprPricingPlanElement, ZprPricingPlanEvents, Components.ZprPricingPlan>({
    tagName: 'zpr-pricing-plan',
    elementClass: ZprPricingPlanElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprPricingPlanEvents,
    defineCustomElement: defineZprPricingPlan
});

export type ZprPricingPlansEvents = NonNullable<unknown>;

export const ZprPricingPlans: StencilReactComponent<ZprPricingPlansElement, ZprPricingPlansEvents, Components.ZprPricingPlans> = /*@__PURE__*/ createComponent<ZprPricingPlansElement, ZprPricingPlansEvents, Components.ZprPricingPlans>({
    tagName: 'zpr-pricing-plans',
    elementClass: ZprPricingPlansElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprPricingPlansEvents,
    defineCustomElement: defineZprPricingPlans
});

export type ZprProgressRingEvents = NonNullable<unknown>;

export const ZprProgressRing: StencilReactComponent<ZprProgressRingElement, ZprProgressRingEvents, Components.ZprProgressRing> = /*@__PURE__*/ createComponent<ZprProgressRingElement, ZprProgressRingEvents, Components.ZprProgressRing>({
    tagName: 'zpr-progress-ring',
    elementClass: ZprProgressRingElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprProgressRingEvents,
    defineCustomElement: defineZprProgressRing
});

export type ZprProgressTabEvents = { onTabChanged: EventName<ZprProgressTabCustomEvent<any>> };

export const ZprProgressTab: StencilReactComponent<ZprProgressTabElement, ZprProgressTabEvents, Components.ZprProgressTab> = /*@__PURE__*/ createComponent<ZprProgressTabElement, ZprProgressTabEvents, Components.ZprProgressTab>({
    tagName: 'zpr-progress-tab',
    elementClass: ZprProgressTabElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onTabChanged: 'tabChanged' } as ZprProgressTabEvents,
    defineCustomElement: defineZprProgressTab
});

export type ZprProgressTabPanelEvents = {
    onVideoPlayed: EventName<ZprProgressTabPanelCustomEvent<any>>,
    onVideoEnded: EventName<ZprProgressTabPanelCustomEvent<any>>
};

export const ZprProgressTabPanel: StencilReactComponent<ZprProgressTabPanelElement, ZprProgressTabPanelEvents, Components.ZprProgressTabPanel> = /*@__PURE__*/ createComponent<ZprProgressTabPanelElement, ZprProgressTabPanelEvents, Components.ZprProgressTabPanel>({
    tagName: 'zpr-progress-tab-panel',
    elementClass: ZprProgressTabPanelElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onVideoPlayed: 'videoPlayed',
        onVideoEnded: 'videoEnded'
    } as ZprProgressTabPanelEvents,
    defineCustomElement: defineZprProgressTabPanel
});

export type ZprProgressTabsEvents = NonNullable<unknown>;

export const ZprProgressTabs: StencilReactComponent<ZprProgressTabsElement, ZprProgressTabsEvents, Components.ZprProgressTabs> = /*@__PURE__*/ createComponent<ZprProgressTabsElement, ZprProgressTabsEvents, Components.ZprProgressTabs>({
    tagName: 'zpr-progress-tabs',
    elementClass: ZprProgressTabsElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprProgressTabsEvents,
    defineCustomElement: defineZprProgressTabs
});

export type ZprRadioItemEvents = { onSelected: EventName<ZprRadioItemCustomEvent<any>> };

export const ZprRadioItem: StencilReactComponent<ZprRadioItemElement, ZprRadioItemEvents, Components.ZprRadioItem> = /*@__PURE__*/ createComponent<ZprRadioItemElement, ZprRadioItemEvents, Components.ZprRadioItem>({
    tagName: 'zpr-radio-item',
    elementClass: ZprRadioItemElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onSelected: 'selected' } as ZprRadioItemEvents,
    defineCustomElement: defineZprRadioItem
});

export type ZprRadioListEvents = { onChanged: EventName<ZprRadioListCustomEvent<any>> };

export const ZprRadioList: StencilReactComponent<ZprRadioListElement, ZprRadioListEvents, Components.ZprRadioList> = /*@__PURE__*/ createComponent<ZprRadioListElement, ZprRadioListEvents, Components.ZprRadioList>({
    tagName: 'zpr-radio-list',
    elementClass: ZprRadioListElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onChanged: 'changed' } as ZprRadioListEvents,
    defineCustomElement: defineZprRadioList
});

export type ZprRangeSelectorPanelEvents = { onDatepickerPanelSelect: EventName<ZprRangeSelectorPanelCustomEvent<DatepickerDaySelectDetail>> };

export const ZprRangeSelectorPanel: StencilReactComponent<ZprRangeSelectorPanelElement, ZprRangeSelectorPanelEvents, Components.ZprRangeSelectorPanel> = /*@__PURE__*/ createComponent<ZprRangeSelectorPanelElement, ZprRangeSelectorPanelEvents, Components.ZprRangeSelectorPanel>({
    tagName: 'zpr-range-selector-panel',
    elementClass: ZprRangeSelectorPanelElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onDatepickerPanelSelect: 'datepicker-panel-select' } as ZprRangeSelectorPanelEvents,
    defineCustomElement: defineZprRangeSelectorPanel
});

export type ZprSelectEvents = { onSelectchanged: EventName<ZprSelectCustomEvent<{ value: string, label: string }>> };

export const ZprSelect: StencilReactComponent<ZprSelectElement, ZprSelectEvents, Components.ZprSelect> = /*@__PURE__*/ createComponent<ZprSelectElement, ZprSelectEvents, Components.ZprSelect>({
    tagName: 'zpr-select',
    elementClass: ZprSelectElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onSelectchanged: 'selectchanged' } as ZprSelectEvents,
    defineCustomElement: defineZprSelect
});

export type ZprSelectOptionEvents = NonNullable<unknown>;

export const ZprSelectOption: StencilReactComponent<ZprSelectOptionElement, ZprSelectOptionEvents, Components.ZprSelectOption> = /*@__PURE__*/ createComponent<ZprSelectOptionElement, ZprSelectOptionEvents, Components.ZprSelectOption>({
    tagName: 'zpr-select-option',
    elementClass: ZprSelectOptionElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprSelectOptionEvents,
    defineCustomElement: defineZprSelectOption
});

export type ZprSelectOptionGroupEvents = NonNullable<unknown>;

export const ZprSelectOptionGroup: StencilReactComponent<ZprSelectOptionGroupElement, ZprSelectOptionGroupEvents, Components.ZprSelectOptionGroup> = /*@__PURE__*/ createComponent<ZprSelectOptionGroupElement, ZprSelectOptionGroupEvents, Components.ZprSelectOptionGroup>({
    tagName: 'zpr-select-option-group',
    elementClass: ZprSelectOptionGroupElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprSelectOptionGroupEvents,
    defineCustomElement: defineZprSelectOptionGroup
});

export type ZprSelectWithFilterEvents = { onChanged: EventName<ZprSelectWithFilterCustomEvent<string>> };

export const ZprSelectWithFilter: StencilReactComponent<ZprSelectWithFilterElement, ZprSelectWithFilterEvents, Components.ZprSelectWithFilter> = /*@__PURE__*/ createComponent<ZprSelectWithFilterElement, ZprSelectWithFilterEvents, Components.ZprSelectWithFilter>({
    tagName: 'zpr-select-with-filter',
    elementClass: ZprSelectWithFilterElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onChanged: 'changed' } as ZprSelectWithFilterEvents,
    defineCustomElement: defineZprSelectWithFilter
});

export type ZprSortDropdownEvents = { onSortchanged: EventName<ZprSortDropdownCustomEvent<SortChangedDetail>> };

export const ZprSortDropdown: StencilReactComponent<ZprSortDropdownElement, ZprSortDropdownEvents, Components.ZprSortDropdown> = /*@__PURE__*/ createComponent<ZprSortDropdownElement, ZprSortDropdownEvents, Components.ZprSortDropdown>({
    tagName: 'zpr-sort-dropdown',
    elementClass: ZprSortDropdownElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onSortchanged: 'sortchanged' } as ZprSortDropdownEvents,
    defineCustomElement: defineZprSortDropdown
});

export type ZprStepProgressEvents = NonNullable<unknown>;

export const ZprStepProgress: StencilReactComponent<ZprStepProgressElement, ZprStepProgressEvents, Components.ZprStepProgress> = /*@__PURE__*/ createComponent<ZprStepProgressElement, ZprStepProgressEvents, Components.ZprStepProgress>({
    tagName: 'zpr-step-progress',
    elementClass: ZprStepProgressElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprStepProgressEvents,
    defineCustomElement: defineZprStepProgress
});

export type ZprSwitcherButtonEvents = {
    onChanged: EventName<ZprSwitcherButtonCustomEvent<any>>,
    onSwitcherChange: EventName<ZprSwitcherButtonCustomEvent<any>>
};

export const ZprSwitcherButton: StencilReactComponent<ZprSwitcherButtonElement, ZprSwitcherButtonEvents, Components.ZprSwitcherButton> = /*@__PURE__*/ createComponent<ZprSwitcherButtonElement, ZprSwitcherButtonEvents, Components.ZprSwitcherButton>({
    tagName: 'zpr-switcher-button',
    elementClass: ZprSwitcherButtonElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onChanged: 'changed',
        onSwitcherChange: 'switcherChange'
    } as ZprSwitcherButtonEvents,
    defineCustomElement: defineZprSwitcherButton
});

export type ZprSwitcherButtonItemEvents = NonNullable<unknown>;

export const ZprSwitcherButtonItem: StencilReactComponent<ZprSwitcherButtonItemElement, ZprSwitcherButtonItemEvents, Components.ZprSwitcherButtonItem> = /*@__PURE__*/ createComponent<ZprSwitcherButtonItemElement, ZprSwitcherButtonItemEvents, Components.ZprSwitcherButtonItem>({
    tagName: 'zpr-switcher-button-item',
    elementClass: ZprSwitcherButtonItemElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprSwitcherButtonItemEvents,
    defineCustomElement: defineZprSwitcherButtonItem
});

export type ZprTabEvents = { onTabChange: EventName<ZprTabCustomEvent<any>> };

export const ZprTab: StencilReactComponent<ZprTabElement, ZprTabEvents, Components.ZprTab> = /*@__PURE__*/ createComponent<ZprTabElement, ZprTabEvents, Components.ZprTab>({
    tagName: 'zpr-tab',
    elementClass: ZprTabElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onTabChange: 'tabChange' } as ZprTabEvents,
    defineCustomElement: defineZprTab
});

export type ZprTableEvents = { onSelectionchanged: EventName<ZprTableCustomEvent<TableSelectionDetail>> };

export const ZprTable: StencilReactComponent<ZprTableElement, ZprTableEvents, Components.ZprTable> = /*@__PURE__*/ createComponent<ZprTableElement, ZprTableEvents, Components.ZprTable>({
    tagName: 'zpr-table',
    elementClass: ZprTableElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onSelectionchanged: 'selectionchanged' } as ZprTableEvents,
    defineCustomElement: defineZprTable
});

export type ZprTableTdEvents = NonNullable<unknown>;

export const ZprTableTd: StencilReactComponent<ZprTableTdElement, ZprTableTdEvents, Components.ZprTableTd> = /*@__PURE__*/ createComponent<ZprTableTdElement, ZprTableTdEvents, Components.ZprTableTd>({
    tagName: 'zpr-table-td',
    elementClass: ZprTableTdElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprTableTdEvents,
    defineCustomElement: defineZprTableTd
});

export type ZprTableTdActionEvents = NonNullable<unknown>;

export const ZprTableTdAction: StencilReactComponent<ZprTableTdActionElement, ZprTableTdActionEvents, Components.ZprTableTdAction> = /*@__PURE__*/ createComponent<ZprTableTdActionElement, ZprTableTdActionEvents, Components.ZprTableTdAction>({
    tagName: 'zpr-table-td-action',
    elementClass: ZprTableTdActionElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprTableTdActionEvents,
    defineCustomElement: defineZprTableTdAction
});

export type ZprTableTdImgEvents = { onImageActivated: EventName<ZprTableTdImgCustomEvent<void>> };

export const ZprTableTdImg: StencilReactComponent<ZprTableTdImgElement, ZprTableTdImgEvents, Components.ZprTableTdImg> = /*@__PURE__*/ createComponent<ZprTableTdImgElement, ZprTableTdImgEvents, Components.ZprTableTdImg>({
    tagName: 'zpr-table-td-img',
    elementClass: ZprTableTdImgElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onImageActivated: 'image-activated' } as ZprTableTdImgEvents,
    defineCustomElement: defineZprTableTdImg
});

export type ZprTableTrEvents = {
    onTableColumnSelect: EventName<ZprTableTrCustomEvent<TableColumnSelectDetail>>,
    onTableRowSelect: EventName<ZprTableTrCustomEvent<TableRowSelectDetail>>
};

export const ZprTableTr: StencilReactComponent<ZprTableTrElement, ZprTableTrEvents, Components.ZprTableTr> = /*@__PURE__*/ createComponent<ZprTableTrElement, ZprTableTrEvents, Components.ZprTableTr>({
    tagName: 'zpr-table-tr',
    elementClass: ZprTableTrElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onTableColumnSelect: 'table-column-select',
        onTableRowSelect: 'table-row-select'
    } as ZprTableTrEvents,
    defineCustomElement: defineZprTableTr
});

export type ZprTabsEvents = { onTabsChange: EventName<ZprTabsCustomEvent<any>> };

export const ZprTabs: StencilReactComponent<ZprTabsElement, ZprTabsEvents, Components.ZprTabs> = /*@__PURE__*/ createComponent<ZprTabsElement, ZprTabsEvents, Components.ZprTabs>({
    tagName: 'zpr-tabs',
    elementClass: ZprTabsElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onTabsChange: 'tabs-change' } as ZprTabsEvents,
    defineCustomElement: defineZprTabs
});

export type ZprTabsVerticalEvents = NonNullable<unknown>;

export const ZprTabsVertical: StencilReactComponent<ZprTabsVerticalElement, ZprTabsVerticalEvents, Components.ZprTabsVertical> = /*@__PURE__*/ createComponent<ZprTabsVerticalElement, ZprTabsVerticalEvents, Components.ZprTabsVertical>({
    tagName: 'zpr-tabs-vertical',
    elementClass: ZprTabsVerticalElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprTabsVerticalEvents,
    defineCustomElement: defineZprTabsVertical
});

export type ZprTagsInputEvents = { onTagsChanged: EventName<ZprTagsInputCustomEvent<string[]>> };

export const ZprTagsInput: StencilReactComponent<ZprTagsInputElement, ZprTagsInputEvents, Components.ZprTagsInput> = /*@__PURE__*/ createComponent<ZprTagsInputElement, ZprTagsInputEvents, Components.ZprTagsInput>({
    tagName: 'zpr-tags-input',
    elementClass: ZprTagsInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onTagsChanged: 'tags-changed' } as ZprTagsInputEvents,
    defineCustomElement: defineZprTagsInput
});

export type ZprTagsListEvents = NonNullable<unknown>;

export const ZprTagsList: StencilReactComponent<ZprTagsListElement, ZprTagsListEvents, Components.ZprTagsList> = /*@__PURE__*/ createComponent<ZprTagsListElement, ZprTagsListEvents, Components.ZprTagsList>({
    tagName: 'zpr-tags-list',
    elementClass: ZprTagsListElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprTagsListEvents,
    defineCustomElement: defineZprTagsList
});

export type ZprTextInputEvents = {
    onInputChanged: EventName<ZprTextInputCustomEvent<TextInputChangeDetail>>,
    onValueChanged: EventName<ZprTextInputCustomEvent<string | number>>
};

export const ZprTextInput: StencilReactComponent<ZprTextInputElement, ZprTextInputEvents, Components.ZprTextInput> = /*@__PURE__*/ createComponent<ZprTextInputElement, ZprTextInputEvents, Components.ZprTextInput>({
    tagName: 'zpr-text-input',
    elementClass: ZprTextInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onInputChanged: 'input-changed',
        onValueChanged: 'value-changed'
    } as ZprTextInputEvents,
    defineCustomElement: defineZprTextInput
});

export type ZprToastEvents = NonNullable<unknown>;

export const ZprToast: StencilReactComponent<ZprToastElement, ZprToastEvents, Components.ZprToast> = /*@__PURE__*/ createComponent<ZprToastElement, ZprToastEvents, Components.ZprToast>({
    tagName: 'zpr-toast',
    elementClass: ZprToastElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprToastEvents,
    defineCustomElement: defineZprToast
});

export type ZprToastsEvents = NonNullable<unknown>;

export const ZprToasts: StencilReactComponent<ZprToastsElement, ZprToastsEvents, Components.ZprToasts> = /*@__PURE__*/ createComponent<ZprToastsElement, ZprToastsEvents, Components.ZprToasts>({
    tagName: 'zpr-toasts',
    elementClass: ZprToastsElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as ZprToastsEvents,
    defineCustomElement: defineZprToasts
});

export type ZprToggleEvents = { onChanged: EventName<ZprToggleCustomEvent<any>> };

export const ZprToggle: StencilReactComponent<ZprToggleElement, ZprToggleEvents, Components.ZprToggle> = /*@__PURE__*/ createComponent<ZprToggleElement, ZprToggleEvents, Components.ZprToggle>({
    tagName: 'zpr-toggle',
    elementClass: ZprToggleElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onChanged: 'changed' } as ZprToggleEvents,
    defineCustomElement: defineZprToggle
});

export type ZprToggleItemEvents = { onSelected: EventName<ZprToggleItemCustomEvent<any>> };

export const ZprToggleItem: StencilReactComponent<ZprToggleItemElement, ZprToggleItemEvents, Components.ZprToggleItem> = /*@__PURE__*/ createComponent<ZprToggleItemElement, ZprToggleItemEvents, Components.ZprToggleItem>({
    tagName: 'zpr-toggle-item',
    elementClass: ZprToggleItemElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onSelected: 'selected' } as ZprToggleItemEvents,
    defineCustomElement: defineZprToggleItem
});

export type ZprTooltipEvents = { onTooltipOpen: EventName<ZprTooltipCustomEvent<any>> };

export const ZprTooltip: StencilReactComponent<ZprTooltipElement, ZprTooltipEvents, Components.ZprTooltip> = /*@__PURE__*/ createComponent<ZprTooltipElement, ZprTooltipEvents, Components.ZprTooltip>({
    tagName: 'zpr-tooltip',
    elementClass: ZprTooltipElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onTooltipOpen: 'tooltip-open' } as ZprTooltipEvents,
    defineCustomElement: defineZprTooltip
});

export type ZprTooltipInputEvents = { onTooltipinputChanged: EventName<ZprTooltipInputCustomEvent<string>> };

export const ZprTooltipInput: StencilReactComponent<ZprTooltipInputElement, ZprTooltipInputEvents, Components.ZprTooltipInput> = /*@__PURE__*/ createComponent<ZprTooltipInputElement, ZprTooltipInputEvents, Components.ZprTooltipInput>({
    tagName: 'zpr-tooltip-input',
    elementClass: ZprTooltipInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onTooltipinputChanged: 'tooltipinput-changed' } as ZprTooltipInputEvents,
    defineCustomElement: defineZprTooltipInput
});
